import Link from "next/link";
import { useRouter } from "next/router";
import React, { useState } from "react";
import {
  Button,
  Container,
  Form,
  Row,
  Col,
  Tab,
  Tabs,
  Nav,
  Breadcrumb,
  BreadcrumbItem,
} from "react-bootstrap";
import { scheduleMeeting } from "../api.services.js/others";
import swal from "sweetalert";
import Head from "next/head";
import { gtagConversionEvent } from "../gtag";

const Signaturecompany = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [date1, setDate1] = useState("");
  const [store, setStore] = useState("");
  const [whomi, setWhomi] = useState("");
  const [requirement, setRequirement] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const imageSourcesChennai = [
    "https://www.orientbell.com/media/chennai_coco/500x244%20Pix_1.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x244%20Pix_10.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x244%20Pix_11.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x244%20Pix_12.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x244%20Pix_13.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x244%20Pix_2.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x244%20Pix_3.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x244%20Pix_4.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x244%20Pix_5.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x244%20Pix_6.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x244%20Pix_7.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x244%20Pix_8.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x244%20Pix_9.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x500%20Pix_1.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x500%20Pix_10.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x500%20Pix_11.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x500%20Pix_12.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x500%20Pix_13.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x500%20Pix_14.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x500%20Pix_2.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x500%20Pix_3.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x500%20Pix_4.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x500%20Pix_5.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x500%20Pix_6.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x500%20Pix_7.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x500%20Pix_8.jpg",
    "https://www.orientbell.com/media/chennai_coco/500x500%20Pix_9.jpg"
  ];

  
const imageSourcesDelhi = [
  "https://www.orientbell.com/media/delhi_coco/500x244%20Pix_1.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x244%20Pix_2.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x244%20Pix_3.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x244%20Pix_4.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x244%20Pix_5.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x244%20Pix_6.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x244%20Pix_7.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x244%20Pix_8.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_1.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_10.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_11.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_12.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_13.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_14.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_15.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_16.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_17.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_18.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_19.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_2.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_20.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_21.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_22.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_23.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_3.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_4.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_5.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_6.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_7.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_8.jpg",
  "https://www.orientbell.com/media/delhi_coco/500x500%20Pix_9.jpg"
];

const imageSourcesKolkata=[
  "https://www.orientbell.com/media/kolkata_coco/500x244%20Pix_1.jpg",
  "https://www.orientbell.com/media/kolkata_coco/500x244%20Pix_2.jpg",
  "https://www.orientbell.com/media/kolkata_coco/500x244%20Pix_3.jpg",
  "https://www.orientbell.com/media/kolkata_coco/500x244%20Pix_4.jpg",
  "https://www.orientbell.com/media/kolkata_coco/500x244%20Pix_5.jpg",
  "https://www.orientbell.com/media/kolkata_coco/500x244%20Pix_6.jpg",
  "https://www.orientbell.com/media/kolkata_coco/500x244%20Pix_7.jpg",
  "https://www.orientbell.com/media/kolkata_coco/500x244%20Pix_8.jpg",
  "https://www.orientbell.com/media/kolkata_coco/500x500%20Pix_1.jpg",
  "https://www.orientbell.com/media/kolkata_coco/500x500%20Pix_2.jpg"
];
 const imageSourcesPune=[
  "https://www.orientbell.com/media/pune_coco/500x244%20Pix_1.jpg",
  "https://www.orientbell.com/media/pune_coco/500x244%20Pix_10.jpg",
  "https://www.orientbell.com/media/pune_coco/500x244%20Pix_2.jpg",
  "https://www.orientbell.com/media/pune_coco/500x244%20Pix_3.jpg",
  "https://www.orientbell.com/media/pune_coco/500x244%20Pix_4.jpg",
  "https://www.orientbell.com/media/pune_coco/500x244%20Pix_5.jpg",
  "https://www.orientbell.com/media/pune_coco/500x244%20Pix_6.jpg",
  "https://www.orientbell.com/media/pune_coco/500x244%20Pix_7.jpg",
  "https://www.orientbell.com/media/pune_coco/500x244%20Pix_8.jpg",
  "https://www.orientbell.com/media/pune_coco/500x244%20Pix_9.jpg",
  "https://www.orientbell.com/media/pune_coco/500x500%20Pix_1.jpg",
  "https://www.orientbell.com/media/pune_coco/500x500%20Pix_10.jpg",
  "https://www.orientbell.com/media/pune_coco/500x500%20Pix_2.jpg",
  "https://www.orientbell.com/media/pune_coco/500x500%20Pix_3.jpg",
  "https://www.orientbell.com/media/pune_coco/500x500%20Pix_4.jpg",
  "https://www.orientbell.com/media/pune_coco/500x500%20Pix_5.jpg",
  "https://www.orientbell.com/media/pune_coco/500x500%20Pix_6.jpg",
  "https://www.orientbell.com/media/pune_coco/500x500%20Pix_7.jpg",
  "https://www.orientbell.com/media/pune_coco/500x500%20Pix_8.jpg",
  "https://www.orientbell.com/media/pune_coco/500x500%20Pix_9.jpg"
 ];

 const imageSourcesCochin=[
"https://images.orientbell.com/media/.thumbs/500x500_Pix_1.jpg?rand=1716801018",
"https://images.orientbell.com/media/.thumbs/500x500_Pix_2.jpg?rand=1716801018",
"https://images.orientbell.com/media/.thumbs/500x500_Pix_4.jpg?rand=1716801018",
"https://images.orientbell.com/media/.thumbs/500x500_Pix_3.jpg?rand=1716801018",
"https://images.orientbell.com/media/.thumbs/500x244_Pix_1.jpg?rand=1716801018",
"https://images.orientbell.com/media/.thumbs/500x244_Pix_2.jpg?rand=1716801018",
"https://images.orientbell.com/media/.thumbs/500x244_Pix_4.jpg?rand=1716801018",
"https://images.orientbell.com/media/.thumbs/500x244_Pix_3.jpg?rand=1716801018"
] 

const imageSourcesLucknow=[
  "https://images.orientbell.com/media/.thumbs/500x244_Pix_4_1.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x244_Pix_5.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x244_Pix_6.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x244_Pix_7.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x244_Pix_3_1.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x500_Pix_8.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x500_Pix_14.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x500_Pix_13.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x500_Pix_11.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x244_Pix_1_1.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x500_Pix_16.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x244_Pix_2_1.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x500_Pix_15.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x500_Pix_10.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x500_Pix_7.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x500_Pix_9.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x500_Pix_12.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x500_Pix_4_1.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x500_Pix_3_1.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x500_Pix_2_1.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x500_Pix_6.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x500_Pix_5.jpg?rand=1716801375",
  "https://images.orientbell.com/media/.thumbs/500x500_Pix_1_1.jpg?rand=1716801375",
  

]
 const submitForm = async (e) => {
    e.preventDefault();
    //gtagConversionEvent()
    setLoading(true);
    let response = await scheduleMeeting({
      name,
      mobilenumber: phone,
      email,
      store: store,
      datetimepicker_mask: date1,
      youare: whomi,
      tilesrequirementfor: requirement,
      remarks: message,
    });
    setLoading(false);
    if (response.message) {
      swal(response.message);
    } else {
      swal(response.data.signature_company.msg);
      setName("");
      setPhone("");
      setEmail("");
      setDate1("");
      setStore("");
      setWhomi("");
      setRequirement("");
      setMessage("");
    }
  };

  const breadCrumbSchema = () => {
    return {
      __html: `{
        "@context": "https://schema.org/", 
        "@type": "BreadcrumbList", 
        "itemListElement": [{
          "@type": "ListItem", 
          "position": 1, 
          "name": "Home",
          "item": "https://www.orientbell.com"
        },{
        "@type": "ListItem", 
        "position": 2, 
        "name": "Signature Company Showrooms",
        "item": "https://www.orientbell.com/signature-company-showrooms"
      }]
      }`
    }
  }
  return (
    <>
    <Head>
      <title>
      Orientbell Tiles Signature Company Showrooms - Tiles Shop Near Me
      </title>
    <meta name="title" content="Orientbell Tiles Signature Company Showrooms - Tiles Shop Near Me"/>
<meta name="description" content="Orientbell&#039;s Signature Company Showrooms have variety of tiles in different designs, finishes, and sizes. Find contact details and direction towards the tile showroom near me."/>
<meta name="keywords" content="tiles showroom, tile showroom near me, latest tile showroom, signature company showrooms, orientbell signature company showrooms, orientbell signature company tiles showrooms, orientbell signature company tiles showroom near me"/>
<script type="application/ld+json" dangerouslySetInnerHTML={ breadCrumbSchema()}/>
    </Head>
      <div className="signature-company-showrooms">
        <Container>
        <Breadcrumb>
          <BreadcrumbItem href='https://www.orientbell.com/'>Home</BreadcrumbItem>
		      <BreadcrumbItem href='#'>Premium Tile Boutiques</BreadcrumbItem>
	     	</Breadcrumb>
         
          <div className="Our_stores flex-css">
            <div className="our_stores_data">
              <h2>
                Experience Our Stores In 3D
              </h2>
              <p>
                We offer an exclusive virtual experience that lets you visit
                select stores across the country from the convenience of your
                home.
              </p>
              <Button
                onClick={() => router.push("/3d-virtual-tour-tiles-boutique")}
                variant="primary"
              >
                Experience our stores{" "}
              </Button>
            </div>
            <div className="our_stores_img">
              <img src="../experience-now.jpg" alt='image' />
            </div>
          </div>
          <h1>
            Signature Tiles Showrooms
          </h1>
          <p>
            An Orientbell Signature Company Outlet is your one stop to re-invent
            your space. Packed with latest technology, managers with expertise
            in the tiles industry and a huge variety to select from, these
            outlets are all you need while redesigning your space.
          </p>
          <h3>Why Signature Company Outlets?</h3>
          <p>
            The answer is quite simple. The more options you have to choose
            from, the more flexibility you have while designing your space. And
            this is the main objective of our Signature Company Outlets. These
            stores are equipped with everything you’d need to visualise and
            redesign your place. From expertise to a visual experience that
            can’t be matched by any other, we deliver it all at our Signature
            Company Outlets. Moreover, these stores are your one stop
            destination to experience our range, buy your favourites and also
            get feedback and guidance for your designs. No matter what your
            business need is, we have got your back!
          </p>
          <div
            className="why_signature flex-css"
            onClick={() => router.push("/trialook")}
          >
            <div className="why_signature_img">
              <img src="../sign-quicklook.jpg" alt='image' />
            </div>
            <div className="why_signature_data">
              <p>
                <strong>QuickLook:</strong> Visualise any space with our
                products in 3 simple steps. All our Signature Company Outlets
                have “QuickLook” installed in them. This tool is designed to
                help you imagine and picture how any space (Kitchen, Bathroom,
                Office Space, etc.) will look with our products accentuating its
                beauty. All you got to do is select the space, choose the tiles
                you want to install, and get not just one but four different
                options to design your space with tiles selected by you.
              </p>
            </div>
          </div>
          <div className="why_signature_trulook why_signature flex-css">
            <div className="why_signature_img">
              <img src="../sign-trulook.jpg" alt='image' />
            </div>
            <div className="why_signature_data">
              <p>
                <strong>TruLook:</strong> Another example of how we are using
                latest technology to bring you the best services. Sometimes,
                it’s difficult to imagine your space in a completely new design.
                Well, look no further. TruLook helps you visualize your own
                space with Orientbell Tiles, all you need to do is send us
                photographs or dimensions of your room and our experts will
                design it exclusively for you with hard to refuse options.{" "}
                <Link href="">Click here to request TruLook today!</Link>
              </p>
            </div>
          </div>
          <div className="why_signature flex-css">
            <div className="why_signature_img">
              <img src="../sign-mockup.jpg" alt='image' />
            </div>
            <div className="why_signature_data">
              <p>
                <strong>Mock-ups:</strong> Orientbell Signature Company Outlets
                are also loaded with special mock-ups. These are specially
                designed for architects with complete design concepts in place.
                From wall concepts to floor concepts, these mock-ups are created
                to help you imagine and visualise any space.
              </p>
            </div>
          </div>
          <div className="why_signature_trulook why_signature flex-css">
            <div className="why_signature_img">
              <img src="../sign-expertise.jpg" alt='image' />
            </div>
            <div className="why_signature_data">
              <p>
                <strong>Expertise:</strong> At our Signature Company Outlets,
                you will find store managers who have been trained to provide
                you expert knowledge on tiles. They will help you select the
                best option according to your requirements. Just walk in and
                tell them what you are looking for, and they will take it
                forward!
              </p>
            </div>
          </div>
          <div className="why_signature flex-css">
            <div className="why_signature_img">
              <img src="../sign-exclusivity.jpg" alt='image' />
            </div>
            <div className="why_signature_data">
              <p>
                <strong>Exclusivity:</strong> Our Signature Company Outlets are
                exclusively packed with Orientbell products. This results in
                less confusion and more efficiency. You get to view our entire
                range and design your own concepts, from just our tiles.
              </p>
            </div>
          </div>
          <div className="appointment_book">
            <h5>BOOK A FREE APPOINTMENT WITH OUR TILE EXPERT</h5>
            <p>
              <strong>Personal Details</strong>
            </p>
            <Form onSubmit={submitForm}>
              <Row>
                <Col md={4} xs={12} className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Enter Your Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </Col>
                <Col md={4} xs={12} className="mb-3">
                  <Form.Control
                    type="email"
                    placeholder="Enter Your email ID"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Col>
                <Col md={4} xs={12} className="mb-3">
                  <Form.Control
                    type="number"
                    placeholder="Enter your phone number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    min={10}
                    required
                  />
                </Col>
              </Row>
              <Row>
                <Col md={8} xs={12} className="mb-3">
                  {!date1 && (
                    <label
                      style={{
                        top: "10px",
                        left: "10px",
                        color: "#aaa",
                      }}
                    >
                      Select Appointment Date
                    </label>
                  )}
                  <Form.Control
                    type="date"
                    required
                    value={date1}
                    onChange={(e) => setDate1(e.target.value)}
                  />
                </Col>
                <Col md={4} xs={12} className="mb-3">
                  <Form.Select
                    value={store}
                    onChange={(e) => setStore(e.target.value)}
                    required
                  >
                    <option value="">Select Store</option>
                    {/* <option value="Delhi">Delhi</option> */}
                    <option value="Pune">Pune</option>
                    <option value="Chandigarh">Chandigarh</option>
                    <option value="Kolkata">Kolkata</option>
                    <option value="Chennai">Chennai</option>
                    {/* <option value="Coimbatore">Coimbatore</option> */}
                    <option value="Kochi">Kochi</option>
                    <option value="Vadodara">Vadodara</option>
                    <option value="Dehradun">Dehradun</option>
                  </Form.Select>
                </Col>
              </Row>
              <Row>
                <Col md={4} xs={12} className="mb-3">
                  <Form.Select
                    value={whomi}
                    onChange={(e) => setWhomi(e.target.value)}
                    required
                  >
                    <option value="">You Are</option>
                    <option value="Homeowner">Homeowner</option>
                    <option value="Architect/Interior Designer">
                      Architect/Interior Designer
                    </option>
                    <option value="Builder">Builder</option>
                    <option value="Contractor">Contractor</option>
                    <option value="Mason">Mason</option>
                    <option value="Others">Others</option>
                  </Form.Select>
                </Col>
                <Col md={4} xs={12} className="mb-3">
                  <Form.Select
                    value={requirement}
                    onChange={(e) => setRequirement(e.target.value)}
                    required
                  >
                    <option value="">Tiles Requirement for</option>
                    <option value="Home">Home</option>
                    <option value="Commercial/Business">
                      Commercial/Business
                    </option>
                    <option value="Others">Others</option>
                  </Form.Select>
                </Col>
              </Row>
              <Row>
                <Col md={8} xs={12}>
                  <Form.Control
                    type="text"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    as="textarea"
                    placeholder="Remarks"
                    style={{ height: "120px" }}
                  />
                </Col>
                <Col md={4} xs={12}>
                  <Form.Group controlId="formBasicCheckbox">
                    <div style={{ display: "flex" }}>
                      <Form.Check
                        type="checkbox"
                        label="I abide by the Orientbell"
                        feedback="You must agree before submitting."
                        feedbackType="invalid"
                        required
                        style={{
                          color: "#747474",
                          fontWeight: "100 !important",
                          marginRight: "5px",
                        }}
                      />
                      <a href="/privacy-policy">Privacy Policy</a>
                    </div>
                  </Form.Group>
                  {loading ? (
                    <Button variant="secondary">Submit</Button>
                  ) : (
                    <Button type="submit" variant="primary">
                      Submit
                    </Button>
                  )}

                  <p>Don’t worry. your details are safe with us</p>
                </Col>
              </Row>
            </Form>
          </div>
          <div className="signature_company_tabs flex-css">
            <Tabs defaultActiveKey="CHENNAI" id="my-tabs">
              <Nav variant="tabs">
                {/* <Nav.Item>
                  <Nav.Link eventKey="CHANDIGARH">CHANDIGARH</Nav.Link>
                </Nav.Item> */}
                <Nav.Item>
                  <Nav.Link eventKey="CHENNAI">CHENNAI</Nav.Link>
                </Nav.Item>
                {/* <Nav.Item>
                  <Nav.Link eventKey="COIMBATORE">COIMBATORE</Nav.Link>
                </Nav.Item> */}
                <Nav.Item>
                  <Nav.Link eventKey="DEHRADUN">DEHRADUN</Nav.Link>
                </Nav.Item>
                {/* <Nav.Item>
                  <Nav.Link eventKey="DELHI">DELHI</Nav.Link>
                </Nav.Item> */}
                <Nav.Item>
                  <Nav.Link eventKey="KOCHI">KOCHI</Nav.Link>
                </Nav.Item>
                {/* <Nav.Item>
                  <Nav.Link eventKey="KOLKATA">KOLKATA</Nav.Link>
                </Nav.Item> */}
                <Nav.Item>
                  <Nav.Link eventKey="LUCKNOW">LUCKNOW</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="PUNE">PUNE</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="VADODARA">VADODARA</Nav.Link>
                </Nav.Item>
              </Nav>

              {/* <Tab eventKey="CHANDIGARH" title="CHANDIGARH">
                <div className="tab_data">
                  <h3>
                    Signature Company Showrooms - Chandigarh
                  </h3>
                  <div className="tab_data_address">
                    <div className="address_data">
                      <p>
                        SCO 6, 1st Floor Sector 7 C, Madhya Marg Chandigarh,
                        160019
                      </p>
                      <p>
                        <strong>
                          Contact Person : Poonam Painuly
                          <br />
                          Phone : 8291364941
                        </strong>
                      </p>
                      <Link href="mailto:poonam.painuly@orientbell.com">
                        poonam.painuly@orientbell.com
                      </Link>
                    </div>
                    <div className="address_data_map">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d27436.408188123864!2d76.797612!3d30.731020000000004!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzDCsDQzJzUxLjciTiA3NsKwNDcnNTEuNCJF!5e0!3m2!1sen!2sus!4v1688205095925!5m2!1sen!2sus"
                        width="100%"
                        height="auto"
                      ></iframe>
                    </div>
                  </div>
                  <p>
                    Located in the heart of tricity, Orientbell Tiles’ Signature
                    Showroom is equipped with latest tiles deigns, styles and
                    sizes. The store will spoil you for choices but trust our
                    tile experts who will help you make a wise decision to make
                    your dream home or a commercial space a reality.
                  </p>
                  <p>
                    Our Chandigarh store is centrally located hence is easily
                    accessible from Mohali, Panchkula and Zirakhpur. Variety,
                    style and array of designs is what makes our Signature Store
                    exclusive. Walk-in anytime of the day to choose tiles for
                    your residential and commercial spaces.
                  </p>
                  <p>
                    Architects and builders love to bring their clients to our
                    store as it is spacious, hospitable and provides personal
                    assistance when it comes to selecting and buying tiles.
                  </p>
                  <p>
                    We don’t just offer the best of quality in products, how
                    about be sure of what you are buying. Choose from our
                    exclusive visualization technology; QuickLook which helps
                    you visualize your preferred space with tiles of your choice
                    in less than 5 seconds. You even get your own space designed
                    by our professionals by requesting TruLook. Simply give us
                    pictures or dimensions of your space and let our experts
                    help you visualise your space better.
                  </p>
                  <p>
                    Well-equipped with mock-ups, displays and slanters that sets
                    the trend right. It’s time you buy tiles just the way you
                    like.
                  </p>
                </div>
                <div className="signature_gallery">
                  <div className="brick">
                    <img
                      alt="Orientbell Signature Company Tiles Showroom in Chandigarh"
                      title="Orientbell Signature Company Tiles Showroom in Chandigarh"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/01.jpeg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/01.jpeg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      alt="Orientbell Tiles Store in Chandigarh"
                      title="Orientbell Tiles Store in Chandigarh"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/02.jpeg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/02.jpeg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      alt="Orientbell Signature Company Tiles Showroom in Chandigarh"
                      title="Orientbell Signature Company Tiles Showroom in Chandigarh"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/03.jpeg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/03.jpeg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      alt="Orientbell Tiles Store in Chandigarh"
                      title="Orientbell Tiles Store in Chandigarh"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/04.jpeg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/04.jpeg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      alt="Orientbell Signature Company Tiles Showroom in Chandigarh"
                      title="Orientbell Signature Company Tiles Showroom in Chandigarh"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/05.jpeg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/05.jpeg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      alt="Orientbell Tiles Store in Chandigarh"
                      title="Orientbell Tiles Store in Chandigarh"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/06.jpeg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/06.jpeg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      alt="Orientbell Signature Company Tiles Showroom in Chandigarh"
                      title="Orientbell Signature Company Tiles Showroom in Chandigarh"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/07.jpeg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/07.jpeg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      alt="Orientbell Tiles Store in Chandigarh"
                      title="Orientbell Tiles Store in Chandigarh"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/08.jpeg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/08.jpeg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      alt="Orientbell Signature Company Tiles Showroom in Chandigarh"
                      title="Orientbell Signature Company Tiles Showroom in Chandigarh"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/09.jpeg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/09.jpeg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      alt="Orientbell Tiles Store in Chandigarh"
                      title="Orientbell Tiles Store in Chandigarh"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/10.jpeg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/10.jpeg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      alt="Orientbell Signature Company Tiles Showroom in Chandigarh"
                      title="Orientbell Signature Company Tiles Showroom in Chandigarh"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/11.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/11.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      alt="Orientbell Tiles Store in Chandigarh"
                      title="Orientbell Tiles Store in Chandigarh"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/12.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Chandigarh/12.jpg"
                    />
                  </div>
                </div>
              </Tab> */}
              <Tab eventKey="CHENNAI" title="CHENNAI">
                <div className="tab_data">
                  <h3>
                   Signature Company Showrooms - Chennai
                  </h3>
                  <div className="tab_data_address">
                    <div className="address_data">
                      <p>
                        2nd floor New No.85, Old No.30, Maharaja Tower, Land
                        Mark Ashok Pillar First Avenue , Ashok Nagar, Chennai,
                        Tamil Nadu, 600083
                      </p>
                      <p>
                        <strong>
                          Contact Person : Vishnu Kr
                          <br />
                          Phone : 9962511617
                        </strong>
                      </p>
                      <Link href="mailto:vishnu.kr@orientbell.com">
                        vishnu.kr@orientbell.com
                      </Link>
                    </div>
                    <div className="address_data_map">
                      <iframe
                        src="https://maps.google.com/maps?q=13.033898120561874,80.2121424846566&amp;z=14&amp;output=embed"
                        width="300"
                        height="170"
                        frameborder="0"
                        marginwidth="0"
                        marginheight="0"
                        scrolling="no"
                      ></iframe>{" "}
                    </div>
                  </div>
                  <p>
                    Architecture and designing dynamics changes when we reach
                    down south with respect to colors, designs and sizes. To
                    cater to our customers in Chennai and to solve all your tile
                    buying queries, Signature Company Showroom of Orientbell
                    Tiles is your one-stop destination. Walk-in to choose from
                    latest tile trends in the world of interiors and exteriors
                    crafted with best quality material the Signature Showroom is
                    answer to all your tile needs. Be it tile experts to assist
                    you choose tiles for your spaces to visualization services
                    like QuickLook and Trulook to help you finalise tiles even
                    before you buy. The store is spacious to accommodate your
                    clients if you are an architect or a builder to help them
                    choose tiles. With parking facility available, it is an
                    experience which will be a hassle free one.
                  </p>
                  <iframe
                    width="853"
                    style={{ "max-width": "100%" }}
                    height="480"
                    src="https://my.matterport.com/show/?m=8vufRtjZ4Ci"
                    frameborder="0"
                    allowfullscreen=""
                    allow="xr-spatial-tracking"
                  ></iframe>
                </div>
                <div className="signature_gallery">
                {imageSourcesChennai.map((src, index) => (
        <div className="brick" key={index}>
          <img
            className=""
            alt={`Orientbell Signature Company Tiles Showroom Image ${index + 1}`}
            title={`Orientbell Signature Company Tiles Showroom Image ${index + 1}`}
            data-src={src}
            src={src}
          />
        </div>))}
                </div>
              </Tab>
              {/* <Tab eventKey="COIMBATORE" title="COIMBATORE">
                <div className="tab_data">
                  <h3>
                    Signature Company Showrooms - Coimbatore
                  </h3>
                  <div className="tab_data_address">
                    <div className="address_data">
                      <p>
                        11, Venkatasamy road (East) R.S.Puram, Coimbatore, Tamil
                        Nadu, 641002
                      </p>
                      <p>
                        <strong>
                          Contact Person : Mohammed Shafeek
                          <br />
                          Phone : 8979941666
                        </strong>
                      </p>
                      <Link href="mailto:alaguraja.muthuraj@orientbell.com">
                        alaguraja.muthuraj@orientbell.com
                      </Link>
                    </div>
                    <div className="address_data_map">
                      <iframe
                        src="https://maps.google.com/maps?q=11.013016718885616,76.954583068787&amp;z=14&amp;output=embed"
                        width="300"
                        height="170"
                        frameborder="0"
                        marginwidth="0"
                        marginheight="0"
                        scrolling="no"
                      ></iframe>{" "}
                    </div>
                  </div>
                  <p>
                    A two-floored showroom stands tall opposite Siemens
                    showroom. Our Signature company showroom is easy to figure
                    out. Find latest designs and trends at our Signature
                    showroom. Our customers love the display and the ease of
                    selecting tiles by space. What works even better are the
                    mockups, kitchen and bathroom mockups are a blessing for so
                    many walk-ins who don’t know what tile or which tile to buy.
                    These mock ups have tiles laid in not just one but multiple
                    patterns to help you visualize your own spaces. That is not
                    it, our tile experts’ guidance through and through help our
                    retail and professional walk-ins select tiles wisely. The
                    tile buying journey which often looks tedious has been
                    simplified using our technology innovation. Now visualize
                    your preferred spaces with tiles of your choice in 3 simple
                    steps with our exclusive technology – QuickLook or request
                    for TruLook by simply providing pictures or dimensions of
                    your space and let our expert designers help you visualize
                    your space with tiles of your choice.
                  </p>
                  <iframe
                    width="853"
                    style={{ "max-width": "100%" }}
                    height="480"
                    src="https://my.matterport.com/show/?m=jRFGEZJbaGk"
                    frameborder="0"
                    allowfullscreen=""
                    allow="xr-spatial-tracking"
                  ></iframe>
                </div>
                <div className="signature_gallery">
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Coimbatore"
                      alt="Orientbell Signature Company Tiles Showroom in Coimbatore"
                      data-src="https://images.orientbell.com/media/wysiwyg/combatore-0.JPG"
                      src="https://images.orientbell.com/media/wysiwyg/combatore-0.JPG"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Tiles Store in Coimbatore"
                      alt="Orientbell Tiles Store in Coimbatore"
                      data-src="https://images.orientbell.com/media/wysiwyg/combatore-1.JPG"
                      src="https://images.orientbell.com/media/wysiwyg/combatore-1.JPG"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Coimbatore"
                      alt="Orientbell Signature Company Tiles Showroom in Coimbatore"
                      data-src="https://images.orientbell.com/media/wysiwyg/combatore-2.JPG"
                      src="https://images.orientbell.com/media/wysiwyg/combatore-2.JPG"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Tiles Store in Coimbatore"
                      alt="Orientbell Tiles Store in Coimbatore"
                      data-src="https://images.orientbell.com/media/wysiwyg/combatore-3.JPG"
                      src="https://images.orientbell.com/media/wysiwyg/combatore-3.JPG"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Coimbatore"
                      alt="Orientbell Signature Company Tiles Showroom in Coimbatore"
                      data-src="https://images.orientbell.com/media/wysiwyg/combatore-4.JPG"
                      src="https://images.orientbell.com/media/wysiwyg/combatore-4.JPG"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Tiles Store in Coimbatore"
                      alt="Orientbell Tiles Store in Coimbatore"
                      data-src="https://images.orientbell.com/media/wysiwyg/combatore-5.JPG"
                      src="https://images.orientbell.com/media/wysiwyg/combatore-5.JPG"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Coimbatore"
                      alt="Orientbell Signature Company Tiles Showroom in Coimbatore"
                      data-src="https://images.orientbell.com/media/wysiwyg/combatore-6.JPG"
                      src="https://images.orientbell.com/media/wysiwyg/combatore-6.JPG"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Tiles Store in Coimbatore"
                      alt="Orientbell Tiles Store in Coimbatore"
                      data-src="https://images.orientbell.com/media/wysiwyg/combatore-7.JPG"
                      src="https://images.orientbell.com/media/wysiwyg/combatore-7.JPG"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Coimbatore"
                      alt="Orientbell Signature Company Tiles Showroom in Coimbatore"
                      data-src="https://images.orientbell.com/media/wysiwyg/combatore-8.JPG"
                      src="https://images.orientbell.com/media/wysiwyg/combatore-8.JPG"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Tiles Store in Coimbatore"
                      alt="Orientbell Tiles Store in Coimbatore"
                      data-src="https://images.orientbell.com/media/wysiwyg/combatore-9.JPG"
                      src="https://images.orientbell.com/media/wysiwyg/combatore-9.JPG"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Coimbatore"
                      alt="Orientbell Signature Company Tiles Showroom in Coimbatore"
                      data-src="https://images.orientbell.com/media/wysiwyg/combatore-10.JPG"
                      src="https://images.orientbell.com/media/wysiwyg/combatore-10.JPG"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Tiles Store in Coimbatore"
                      alt="Orientbell Tiles Store in Coimbatore"
                      data-src="https://images.orientbell.com/media/wysiwyg/combatore-11.JPG"
                      src="https://images.orientbell.com/media/wysiwyg/combatore-11.JPG"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Coimbatore"
                      alt="Orientbell Signature Company Tiles Showroom in Coimbatore"
                      data-src="https://images.orientbell.com/media/wysiwyg/combatore-12.JPG"
                      src="https://images.orientbell.com/media/wysiwyg/combatore-12.JPG"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Tiles Store in Coimbatore"
                      alt="Orientbell Tiles Store in Coimbatore"
                      data-src="https://images.orientbell.com/media/wysiwyg/combatore-13.JPG"
                      src="https://images.orientbell.com/media/wysiwyg/combatore-13.JPG"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Coimbatore"
                      alt="Orientbell Signature Company Tiles Showroom in Coimbatore"
                      data-src="https://images.orientbell.com/media/wysiwyg/combatore-14.JPG"
                      src="https://images.orientbell.com/media/wysiwyg/combatore-14.JPG"
                    />
                  </div>
                </div>
              </Tab> */}
              <Tab eventKey="DEHRADUN" title="DEHRADUN">
                <div className="tab_data">
                  <h3>
                    Signature Company Showrooms - Dehradun
                  </h3>
                  <div className="tab_data_address">
                    <div className="address_data">
                      <p>
                        Duggal Complax Nr. Kamla Place Hotel GMS Road, Dehradun,
                        Uttarakhand, 248001
                      </p>
                      <p>
                        <strong>
                          Contact Person : Yashasvi Mijrawat
                          <br />
                          Phone : 7428594144
                        </strong>
                      </p>
                      <Link href="mailto:yashasvi.mijrawat@orientbell.com">
                        yashasvi.mijrawat@orientbell.com
                      </Link>
                    </div>
                    <div className="address_data_map">
                      <iframe
                        src="https://maps.google.com/maps?q=30.308573972986537,78.00750152644162&amp;z=14&amp;output=embed"
                        width="300"
                        height="170"
                        frameborder="0"
                        marginwidth="0"
                        marginheight="0"
                        scrolling="no"
                      ></iframe>{" "}
                    </div>
                  </div>
                  <p>
                    The Doon valley is known for either its breath-taking
                    landscapes or Signature Company Showrooms where
                    breath-taking designs, styles in colours and sizes of your
                    choices are available under one-roof. With latest tile
                    trends and classic designs, our Dehradun showroom is often
                    visited by architects, builders and contractors for their
                    big and small projects. Our retail customers find our doon
                    store to be a boon as they can seek expert advice for their
                    spaces. The mockups of kitchen, bathroom with our
                    bestselling tiles are laid in multiple patterns and our tool
                    QuickLook to visualize their spaces in 3 simple steps making
                    their tile buying journey a smooth one.
                  </p>
                </div>
                <div className="signature_gallery">
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Dehradun"
                      alt="Orientbell Signature Company Tiles Showroom in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_131805_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_131805_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Tiles Store in Dehradun"
                      alt="Orientbell Tiles Store in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_131824_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_131824_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Dehradun"
                      alt="Orientbell Signature Company Tiles Showroom in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_131856_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_131856_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Tiles Store in Dehradun"
                      alt="Orientbell Tiles Store in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_131949_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_131949_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Dehradun"
                      alt="Orientbell Signature Company Tiles Showroom in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_131959_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_131959_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Tiles Store in Dehradun"
                      alt='Orientbell Tile Boutique Dehradun'
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132005_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132005_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Dehradun"
                      alt="Orientbell Signature Company Tiles Showroom in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132018_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132018_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Tiles Store in Dehradun"
                      alt="Orientbell Tiles Store in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132024_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132024_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Dehradun"
                      alt="Orientbell Signature Company Tiles Showroom in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132030_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132030_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Tiles Store in Dehradun"
                      alt="Orientbell Tiles Store in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132050_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132050_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Dehradun"
                      alt="Orientbell Signature Company Tiles Showroom in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132100_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132100_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Tiles Store in Dehradun"
                      alt="Orientbell Tiles Store in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132142_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132142_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Dehradun"
                      alt="Orientbell Signature Company Tiles Showroom in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132242_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132242_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Tiles Store in Dehradun"
                      alt="Orientbell Tiles Store in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132215_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132215_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Dehradun"
                      alt="Orientbell Signature Company Tiles Showroom in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132301_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132301_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Tiles Store in Dehradun"
                      alt="Orientbell Tiles Store in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132309_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132309_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Dehradun"
                      alt="Orientbell Signature Company Tiles Showroom in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132314_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132314_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Tiles Store in Dehradun"
                      alt="Orientbell Tiles Store in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132328_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132328_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Dehradun"
                      alt="Orientbell Signature Company Tiles Showroom in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132335_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132335_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Tiles Store in Dehradun"
                      alt="Orientbell Tiles Store in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132421_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132421_resized.jpg"
                    />
                  </div>
                  <div className="brick">
                    <img
                      className=""
                      title="Orientbell Signature Company Tiles Showroom in Dehradun"
                      alt="Orientbell Signature Company Tiles Showroom in Dehradun"
                      data-src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132431_resized.jpg"
                      src="https://images.orientbell.com/media/img/tile-boutique/Dehradun/20190607_132431_resized.jpg"
                    />
                  </div>
                </div>
              </Tab>
              {/* <Tab eventKey="DELHI" title="DELHI">
                <div className="tab_data">
                  <h3>
                    Signature Company Showrooms - Delhi
                  </h3>
                  <div className="tab_data_address">
                    <div className="address_data">
                      <p>
                        M 47, M Block market GK – II Delhi – 48, 110048 Near
                        Canara Bank
                      </p>
                      <p>
                        <strong>
                          Contact Person : Nikhil Kumar Gautam
                          <br />
                          Phone : 8373914460
                        </strong>
                      </p>
                    
                    </div>
                    <div className="address_data_map">
                      <iframe
                        src="https://maps.google.com/maps?q=28.533861844417782,77.2425061&amp;z=14&amp;output=embed"
                        width="300"
                        height="170"
                        frameborder="0"
                        marginwidth="0"
                        marginheight="0"
                        scrolling="no"
                      ></iframe>{" "}
                    </div>
                  </div>
                  <p>
                    Delhi is a melting pot of cultures and heritage and
                    Signature Company Showrooms are no different. Designs and
                    styles that suits every style and requirement under one-roof
                    is the USP of our signature showrooms Located in posh
                    Greater Kailash market, Orientbell Tiles’ showroom is the
                    only flagship tile store in the complex, which means you
                    choose from the latest trends and designs available in the
                    market at the best prices. The signature company showroom is
                    a three floor, spacious area well-equipped with mock-ups for
                    bedroom, bathroom, kitchen, and much more. Choose tiles with
                    the help of tile experts, the 3 tile experts available at
                    all times who can help you assist with all your tile buying
                    queries, from size to latest design to even help you
                    visualize your spaces with our exclusive technology in less
                    than 5 seconds – QuickLook or have our experts design your
                    spaces with tiles selected by you with our exclusive service
                    - TruLook.
                  </p>
                  <iframe
                    width="853"
                    height="480"
                    style={{ "max-width": "100%" }}
                    src="https://my.matterport.com/show/?m=iwmxD56sodX"
                    frameborder="0"
                    allowfullscreen=""
                    allow="xr-spatial-tracking"
                  ></iframe>
                </div>

                
                <div className="signature_gallery">
                {imageSourcesDelhi.map((src, index) => (
        <div className="brick" key={index}>
          <img
            className=""
            alt={`Orientbell Signature Company Tiles Showroom Image ${index + 1}`}
            title={`Orientbell Signature Company Tiles Showroom Image ${index + 1}`}
            data-src={src}
            src={src}
          />
        </div>
      ))}
                </div>
              </Tab> */}
              <Tab eventKey="KOCHI" title="KOCHI">
                <div className="tab_data">
                  <h3>
                    Signature Company Showrooms - Kochi
                  </h3>
                  <div className="tab_data_address">
                    <div className="address_data">
                      <p>
                        Surya Gayatri Building No. 32/8, B3 Puthiya Road, New
                        Junction Opp. Holiday Inn Hotal Ernakulam bypass road,
                        Cochin, Kerala, 682031
                      </p>
                      <p>
                        <strong>
                          Contact Person : Raja Lakshmi
                          <br />
                          Phone : 9745768058
                        </strong>
                      </p>
                      <Link href="mailto:raja.lakshmi@orientbell.com">
                        raja.lakshmi@orientbell.com
                      </Link>
                    </div>
                    <div className="address_data_map">
                      <iframe
                        src="https://maps.google.com/maps?q=9.992724286893472,76.31712971797867&amp;z=14&amp;output=embed"
                        width="300"
                        height="170"
                        frameborder="0"
                        marginwidth="0"
                        marginheight="0"
                        scrolling="no"
                      ></iframe>{" "}
                    </div>
                  </div>
                  <p>
                    Located in the port city of Kochi in Kerala, Signature
                    Company Showrooms lets you choose from designs and styles
                    best suited for all your spaces, be it residential or
                    commercial. The technologically advanced experience will
                    surely make your tile-buying experience a much easier and
                    simpler process. The mockups and our exclusive visualization
                    tool – QuickLook helps you imagine your space even before
                    you buy tiles. It a leading choice of architects and
                    builders as they don’t only find perfect tiles for their
                    projects but also the on-time delivery keeps them coming
                    back to our Kochi store. Let’s help you build your dream
                    home. Walk-in now!
                  </p>
                </div>
                <div className="signature_gallery">
                {imageSourcesCochin.map((src, index) => (
        <div className="brick" key={index}>
          <img
            className=""
            alt={`Orientbell Signature Company Tiles Showroom Image ${index + 1}`}
            title={`Orientbell Signature Company Tiles Showroom Image ${index + 1}`}
            data-src={src}
            src={src}
          />
        </div>
      ))}
                </div>
              </Tab>
              {/* <Tab eventKey="KOLKATA" title="KOLKATA">
                <div className="tab_data">
                  <h3>
                    Signature Company Showrooms - Kolkata
                  </h3>
                  <div className="tab_data_address">
                    <div className="address_data">
                      <p>
                        8/1, Burdwan road Alipore, Kolkata, West Bengal, 700027
                      </p>
                      <p>
                        <strong>
                          Contact Person : Ishani Dutta
                          <br />
                          Phone : 8697749329
                        </strong>
                      </p>
                      <Link
                        href="mailto:ishani.dutta@orientbell.com

"
                      >
                        ishani.dutta@orientbell.com
                      </Link>
                    </div>
                    <div className="address_data_map">
                      <iframe
                        src="https://maps.google.com/maps?q=22.522747643700587,88.32696414749171&amp;z=14&amp;output=embed"
                        width="300"
                        height="170"
                        frameborder="0"
                        marginwidth="0"
                        marginheight="0"
                        scrolling="no"
                      ></iframe>{" "}
                    </div>
                  </div>
                  <p>
                    Our Kolkata store is just not another tile showroom, it is
                    part of our legacy and reflects the culture of the city of
                    joy – Kolkata. A lush green entrance, our Signature Company
                    Showroom of Kolkata also happens to be the residence of our
                    Chairman Mr. Mahendra Daga. While the store is equipped with
                    latest designs, and latest tile trends it reflects the
                    essence of Kolkata in all its glory. With ample of parking
                    space, Architects from all corners of Kolkata bring their
                    clients to select tiles. The store is a proof over 40 years
                    of innovation and world-class quality products and is a
                    leading choice of professionals. Our retail walk-ins trust
                    our tile experts and visualization tools like QuickLook and
                    TruLook to help them make a wise choice for all their
                    spaces.
                  </p>
                </div>
                <div className="signature_gallery">
                  <div className="masonry">
                  {imageSourcesKolkata.map((src, index) => (
        <div className="brick" key={index}>
          <img
            className=""
            alt={`Orientbell Signature Company Tiles Showroom Image ${index + 1}`}
            title={`Orientbell Signature Company Tiles Showroom Image ${index + 1}`}
            data-src={src}
            src={src}
          />
        </div>
      ))}
                  </div>
                </div>
              </Tab> */}
              <Tab eventKey="LUCKNOW" title="LUCKNOW">
                <div className="tab_data">
                  <h3>
                    Signature Company Showrooms - Lucknow
                  </h3>
                  <div className="tab_data_address">
                    <div className="address_data">
                      <p>
                        Orient Bell Tile BoutiqueRajrani Apartment G-1 H. No.
                        970/71 Sector- B Near Beej Nigam office Badshah Nagar
                        Railway Station Faizabad Road MahanagarLucknowUttar
                        Pradesh9984200500
                      </p>
                      <p>
                        <strong>
                          Contact Person : Chinmoy Ghosh
                          <br />
                          Phone : 9984786404
                        </strong>
                      </p>
                      <Link href="mailto:chinmoy.ghosh@orientbell.com">
                        chinmoy.ghosh@orientbell.com
                      </Link>
                    </div>
                    <div className="address_data_map">
                      <iframe
                        src="https://maps.google.com/maps?q=26.87140484931816,80.9640372433118&amp;z=14&amp;output=embed"
                        width="300"
                        height="170"
                        frameborder="0"
                        marginwidth="0"
                        marginheight="0"
                        scrolling="no"
                      ></iframe>{" "}
                    </div>
                  </div>
                  <p>
                    Signature Company Showrooms lets you choose tiles just like
                    a ‘nawab’. Array of designs, patterns in colours and sizes
                    as per requirement are all available under one-roof. The
                    tile expertise available at store and exclusive
                    visualization services only makes your tile-buying better
                    than before! The Lucknow showroom is located near Uttar
                    Pradesh Beej Vikas Nigam and is accessible through metro.
                    The nearest metro station is – Badshah Nagar You can walk-in
                    anytime of the day or bring your clients along, the store is
                    open from 10am to 6:30pm. The showroom has inspiring
                    mock-ups of bathroom, kitchen, and living room to give you
                    an idea how tiles will look in your spaces. The store is
                    well-equipped with latest designs and trends in your city,
                    with tile experts to assist you in every step. From
                    selecting designs for your dream home or your big project,
                    there is a design and size available. You can visualize your
                    spaces with our exclusive technology before buying tiles,
                    QuickLook lets you see your preferred space with tiles of
                    your choice in less than 5 seconds. In case you want to get
                    your own space designed with tiles by an expert, ask for
                    TruLook and let our experts design your space even before
                    you finalize tiles.
                  </p>
                </div>
                <div className="signature_gallery">
                  <div className="masonry">
                  
                  {imageSourcesLucknow.map((src, index) => (
        <div className="brick" key={index}>
          <img
            className=""
            alt={`Orientbell Signature Company Tiles Showroom Image ${index + 1}`}
            title={`Orientbell Signature Company Tiles Showroom Image ${index + 1}`}
            data-src={src}
            src={src}
          />
        </div>
      ))}
                  </div>{" "}
                </div>
              </Tab>
              <Tab eventKey="PUNE" title="PUNE">
                <div className="tab_data">
                  <h3>
                    Signature Company Showrooms - Pune
                  </h3>
                  <div className="tab_data_address">
                    <div className="address_data">
                      <p>
                        Shop No 3 and 4 , A tower vega centre , C.T.S. No. 71o,
                        Final Plot No . 401/1, shankarsheth road, Gultekdi,
                        Pune, Maharashtra, 411037
                      </p>
                      <p>
                        <strong>
                          Contact Person : Arbindo Ghosh
                          <br />
                          Phone : 7391072247
                        </strong>
                      </p>
                      <Link href="mailto:arbindo.ghosh@orientbell.com">
                        arbindo.ghosh@orientbell.com
                      </Link>
                    </div>
                    <div className="address_data_map">
                      <iframe
                        src="https://maps.google.com/maps?q=18.499992216207392,73.8626725576717&amp;z=14&amp;output=embed"
                        width="300"
                        height="170"
                        frameborder="0"
                        marginwidth="0"
                        marginheight="0"
                        scrolling="no"
                      ></iframe>{" "}
                    </div>
                  </div>
                  <p>
                    A buzzing market place where homeowners often come to shop
                    the best you’re their spaces. Our Signature Company Showroom
                    in Pune is your one-stop destination for all your tile
                    buying needs. Displaying the latest designs to classic
                    evergreen patterns the store has tile for each space, mood
                    and personality. With tiles laid in multiple patterns in
                    kitchen, bathroom, bedroom and other mockups helps give a
                    better sense of how it will look in your spaces. Get quick
                    designs made through our visualization tool QuickLook to
                    imagine your spaces in 3 simple steps or request TruLook to
                    visualize your spaces in 3 simple steps, our Signature
                    Company showroom is all you need to ease out your tile
                    buying woes.
                  </p>
                </div>
                <div className="signature_gallery">
                  <div className="masonry">
                  {imageSourcesPune.map((src, index) => (
        <div className="brick" key={index}>
          <img
            className=""
            alt={`Orientbell Signature Company Tiles Showroom Image ${index + 1}`}
            title={`Orientbell Signature Company Tiles Showroom Image ${index + 1}`}
            data-src={src}
            src={src}
          />
        </div>
      ))}
                  </div>
                </div>
              </Tab>
              <Tab eventKey="VADODARA" title="VADODARA">
                <div className="tab_data">
                  <h3>
                    Signature Company Showrooms - Vadodara
                  </h3>
                  <div className="tab_data_address">
                    <div className="address_data">
                      <p>
                        78-79, 2nd Floor, Surya Kiran Complex, Beside Banker
                        Heart Institute, Old Padra Road, Vadodara, Gujarat
                        390007
                      </p>
                      <p>
                        <strong>
                          Contact Person : Tapan Thaker
                          <br />
                          Phone : 9727740342
                        </strong>
                      </p>
                      <Link href="mailto:tapan.thaker@orientbell.com">
                        tapan.thaker@orientbell.com
                      </Link>
                    </div>
                    <div className="address_data_map">
                    <iframe src="https://maps.google.com/maps?q=22.297881972041598,73.16446706815933&amp;z=14&amp;output=embed" width="300" height="170" frameborder="0" marginwidth="0" marginheight="0" scrolling="no"></iframe>
                    </div>
                  </div>
                  <p>
                    Our display store in Vadodara is one of its kind, packed
                    with latest designs and collections. This one has the
                    ability to take away the breath of our fellow Vadodara
                    residents!
                  </p>
                </div>
                <div className="signature_gallery">
                <div className="masonry">
            <div className="brick"><img className="" alt="Orientbell Tiles Store in Vadodara" title="Orientbell Tiles Store in Vadodara" data-src="https://images.orientbell.com/media/wysiwyg/gallery-images-1.png" src="https://images.orientbell.com/media/wysiwyg/gallery-images-1.png"/></div>
            <div className="brick"><img className="" alt="Orientbell Signature Company Tiles Showroom in Vadodara" title="Orientbell Signature Company Tiles Showroom in Vadodara" data-src="https://images.orientbell.com/media/wysiwyg/gallery-images-2.png" src="https://images.orientbell.com/media/wysiwyg/gallery-images-2.png"/></div>
            <div className="brick"><img className="" alt="Orientbell Tiles Store in Vadodara" title="Orientbell Tiles Store in Vadodara" data-src="https://images.orientbell.com/media/wysiwyg/gallery-images-3.png" src="https://images.orientbell.com/media/wysiwyg/gallery-images-3.png"/></div>
            <div className="brick"><img className="" alt="Orientbell Signature Company Tiles Showroom in Vadodara" title="Orientbell Signature Company Tiles Showroom in Vadodara" data-src="https://images.orientbell.com/media/wysiwyg/gallery-images-4.png" src="https://images.orientbell.com/media/wysiwyg/gallery-images-4.png"/></div>
            <div className="brick"><img className="" alt="Orientbell Tiles Store in Vadodara" title="Orientbell Tiles Store in Vadodara" data-src="https://images.orientbell.com/media/wysiwyg/gallery-images-5.png" src="https://images.orientbell.com/media/wysiwyg/gallery-images-5.png"/></div>
            <div className="brick"><img className="" alt="Orientbell Signature Company Tiles Showroom in Vadodara" title="Orientbell Signature Company Tiles Showroom in Vadodara" data-src="https://images.orientbell.com/media/wysiwyg/gallery-images-6.png" src="https://images.orientbell.com/media/wysiwyg/gallery-images-6.png"/></div>
            <div className="brick"><img className="" alt="Orientbell Tiles Store in Vadodara" title="Orientbell Tiles Store in Vadodara" data-src="https://images.orientbell.com/media/wysiwyg/gallery-images-7.png" src="https://images.orientbell.com/media/wysiwyg/gallery-images-7.png"/></div>
        </div>
                </div>
              </Tab>
            </Tabs>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Signaturecompany;
